<template><ArticlePage page="update" :content="content" /></template>
<script>
import ArticlePage from '@/components/ArticlePage.vue';
import content from '@/documents/content/update.js';
export default { name: 'Update', components: { ArticlePage }, data: () => ({ content }) };
</script>
